/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Tasks = {
    type: 'array',
    contains: {
        type: 'ResponseTask',
    },
};